import { tokenInstance } from 'lib/axios/instance';

const avatarEndpointPrefix = '/api/v1/avatars';

export const getAvatarProfile = async (avatarId) => {
  return await tokenInstance.get(
    `${avatarEndpointPrefix}/${avatarId}/profiles`,
  );
};
